var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003f87",
    d: "M.7 2.9H54V37H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.3 35.7a15.7 15.7 0 1 0 0-31.4 15.7 15.7 0 0 0 0 31.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#552300",
    strokeWidth: 0.5,
    d: "M27.3 33a13 13 0 1 0 0-26.1 13 13 0 0 0 0 26Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007f00",
    d: "M25.8 6.1c1.2-1.3 2.3.2 2.2.9s-1.2 2.2-2.2 1c1 .2 1.4-1 2-1-.6 0-.8-1.2-2-.9m-12.2 10c-.7-1.7 1.1-2 1.7-1.7s1.5 2 0 2.5c.7-.9-.3-1.7 0-2.2-.3.5-1.5.2-1.7 1.3M40 14.3c1.6.7.6 2.2 0 2.4s-2.5-.4-1.8-1.8c.2 1.1 1.4 1 1.7 1.5-.2-.5.8-1.1 0-2m-21.1 17c-1.7-.1-1.2-1.8-.6-2.2s2.5-.4 2.1 1.2c-.4-1-1.6-.6-2-1 .4.4-.5 1.4.5 2m17.4-1.2c0 1.7-1.7 1.4-2.2.9-.4-.5-.6-2.4 1-2.3-1 .6-.4 1.7-.8 2 .4-.3 1.5.4 2-.6M14.8 12.8c-.1-1.8 1.7-1.6 2.2-1.1s.8 2.4-.8 2.4c1-.7.2-1.8.6-2.2-.4.4-1.5-.2-2 .8m1.9 16c-1.7-.3-1-2-.5-2.3s2.5-.2 2.1 1.4c-.4-1.1-1.6-.7-2-1.2.4.5-.5 1.4.4 2.1M30.2 6.2c1.5-.8 2 1 1.7 1.6-.2.6-1.9 1.6-2.4 0 .9.7 1.6-.3 2.2-.1-.6-.2-.3-1.4-1.5-1.5m3.3 26.2c-.8 1.5-2.2.4-2.4-.3s.6-2.4 2-1.6c-1.2 0-1.2 1.4-1.7 1.5.5-.1 1.1 1 2.1.4m7.5-15c1.3 1.2-.1 2.3-.8 2.3s-2.2-1.2-1-2.3c-.3 1.2 1 1.5 1 2 0-.5 1.2-.8.8-2m-21.9-9c.4-1.7 2-1 2.4-.3s0 2.5-1.5 2c1.1-.4.8-1.6 1.2-1.9-.4.3-1.2-.6-2 .2M14 22.8c-1.5-.9-.4-2.2.3-2.4s2.5.7 1.5 2c0-1.1-1.3-1.2-1.4-1.7.1.5-1 1-.4 2M36 9.5c1.7-.3 1.6 1.5 1.1 2s-2.3 1-2.4-.6c.7.9 1.8.1 2.2.5-.4-.4.2-1.5-1-2M26.2 34c-1.6.7-2-1-1.7-1.7s2-1.5 2.5 0c-1-.7-1.7.4-2.2.1.5.3.2 1.5 1.4 1.6m14.2-9.6c.7 1.6-1 2-1.7 1.7s-1.5-2 0-2.5c-.7 1 .3 1.7.1 2.2.2-.5 1.5-.2 1.6-1.4m-27-5c-1-1.4.6-2.2 1.2-2s2 1.7.5 2.4c.5-1-.6-1.6-.5-2.1-.1.5-1.4.5-1.3 1.7M22.6 33c-1.7.6-2-1.2-1.6-1.8s2-1.4 2.5.2c-.9-.8-1.7.2-2.2 0 .5.2.1 1.4 1.3 1.6m-.5-26.2c1-1.4 2.2-.2 2.3.5s-.8 2.4-2 1.3c1 .1 1.2-1.1 1.7-1.2-.5 0-1-1.1-2-.6m16.7 21c0 1.7-1.7 1.5-2.2 1s-.7-2.4.9-2.3c-1 .6-.3 1.7-.7 2 .4-.3 1.4.4 2-.7m-.5-16.2c1.7.3 1 2 .4 2.3-.6.4-2.5.2-2-1.4.3 1.1 1.6.7 1.9 1.2-.3-.5.6-1.3-.3-2M17 10.4c0-1.7 1.8-1.4 2.2-.8s.6 2.4-1 2.2c1-.5.4-1.7.8-2-.4.3-1.4-.4-2 .6m-2.1 15.5c-1.6-.8-.5-2.2.2-2.3.7-.2 2.4.5 1.6 1.9 0-1.2-1.4-1.1-1.5-1.7.1.6-1 1.1-.4 2.1M33.3 7.6c1.7-.6 2 1.1 1.6 1.7s-2 1.5-2.5 0c.9.7 1.8-.3 2.3 0-.6-.3-.2-1.5-1.4-1.7M30 33.8c-1.3 1.2-2.2-.3-2.2-1 .1-.7 1.4-2.1 2.4-.8-1-.4-1.5.8-2 .8.5 0 .6 1.3 1.8 1m11-13.1c1.2 1.2-.3 2.2-1 2-.7 0-2.1-1.3-.8-2.3-.4 1.1.8 1.5.8 2.1 0-.6 1.3-.7 1-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005800",
    d: "M25.8 8c1 .2 1.3-1 2-1-.4.4-1.3 1.4-2 1m0-1.9c1.2-1.3 2.3.2 2.2.9-1-1.7-1.2-1.4-2.2-.9M15.2 16.9c.8-.9-.2-1.7 0-2.2.2.5.7 1.7 0 2.2m-1.6-.9c-.7-1.6 1.1-1.9 1.7-1.6-1.9.1-1.8.5-1.7 1.6m24.6-1c.1 1.1 1.4 1 1.6 1.5-.5-.2-1.7-.6-1.6-1.5m1.8-.6c1.6.7.6 2.2 0 2.4 1.2-1.5.8-1.7 0-2.4m-19.6 16c-.4-1-1.6-.5-2-1 .6 0 2 .1 2 1m-1.5 1c-1.7-.1-1.2-1.8-.6-2.2-.8 1.7-.4 1.8.6 2.3m16.2-2.6c-1 .6-.3 1.6-.7 2 0-.5-.1-1.8.7-2m1.2 1.4c0 1.7-1.7 1.4-2.2.9 1.9.5 2 .1 2.2-.9M16.2 14c1-.6.2-1.6.6-2 0 .5.2 1.8-.6 2m-1.4-1.2c-.1-1.8 1.7-1.6 2.2-1.1-2-.4-2 0-2.2 1m3.5 15c-.4-1-1.6-.6-1.9-1 .5 0 1.8.2 1.9 1m-1.6 1c-1.7-.3-1-2-.5-2.3-.9 1.7-.5 1.8.5 2.3m12.8-21c.9.7 1.6-.3 2.1-.1-.4.2-1.6.9-2.1.2m.7-1.6c1.5-.8 2 1 1.7 1.6-.2-2-.6-1.8-1.7-1.6M33 30.6c-1.1 0-1 1.3-1.6 1.4.2-.4.8-1.6 1.6-1.4m.5 1.8c-.8 1.5-2.2.4-2.4-.3 1.4 1.4 1.6 1 2.4.3m5.7-15c-.3 1.2 1 1.4 1 2-.4-.4-1.5-1.2-1-2m1.8 0c1.3 1.2-.1 2.3-.8 2.3 1.7-1 1.4-1.3.8-2.2m-21-7.3c1.1-.4.7-1.6 1.2-1.8 0 .5-.3 1.8-1.2 1.8m-1-1.8c.4-1.7 2-1 2.4-.3-1.7-1-1.8-.6-2.4.3m-3.3 14c0-1.1-1.2-1.1-1.4-1.6.5.2 1.7.8 1.4 1.6m-1.8.4c-1.5-.9-.4-2.2.3-2.4-1.4 1.4-1 1.6-.3 2.4m20.7-12c.7 1 1.7.2 2.1.5-.5.1-1.8.4-2-.4M36 9.6c1.7-.3 1.6 1.5 1.1 2 .3-1.9 0-1.8-1.1-2m-9 22.8c-1-.7-1.7.4-2.2.2.5-.3 1.7-.9 2.2-.2m-.8 1.7c-1.6.7-2-1-1.7-1.7.2 2 .6 1.8 1.7 1.7m12.5-10.4c-.7 1 .3 1.7.1 2.2-.2-.5-.8-1.7 0-2.2m1.7.8c.7 1.6-1 2-1.7 1.7 2-.2 1.8-.6 1.7-1.7m-25.3-4.6c.5-1-.6-1.5-.5-2 .3.3 1.1 1.4.5 2m-1.8-.4c-1-1.5.7-2.2 1.3-2-1.8.6-1.6 1-1.3 2m10.3 12c-.9-.8-1.7.2-2.2 0 .5-.3 1.7-.8 2.2 0m-1 1.6c-1.6.6-1.9-1.2-1.5-1.8 0 1.9.5 1.8 1.6 1.8m-.2-24.4c1.2.1 1.2-1.1 1.8-1.2-.3.4-1 1.6-1.8 1.2m-.2-1.8c1-1.4 2.2-.2 2.3.5-1.2-1.5-1.4-1.2-2.3-.5m15.4 19.7c-1 .6-.3 1.6-.7 2 0-.5-.2-1.8.7-2m1.3 1.3c0 1.7-1.7 1.5-2.2 1 1.9.5 2 0 2.2-1M37 12.6c.3 1.1 1.5.7 1.8 1.2-.5-.1-1.8-.3-1.8-1.2m1.6-.9c1.7.3 1 2 .4 2.3 1-1.6.6-1.8-.4-2.3m-20.3.2c1-.5.4-1.6.8-2 0 .5 0 1.8-.8 2M17 10.4c0-1.7 1.8-1.4 2.2-.8-1.8-.6-1.8-.2-2.2.8m-.3 15c0-1-1.3-1-1.5-1.5.5.2 1.7.7 1.5 1.6m-1.9.5c-1.5-.8-.4-2.2.3-2.3-1.3 1.3-1 1.5-.2 2.3M32.5 9.2c.9.8 1.7-.2 2.2 0-.5.2-1.7.7-2.2 0m1-1.6c1.6-.6 1.9 1.1 1.5 1.8 0-2-.5-1.9-1.6-1.8M30 32c-1-.4-1.5.8-2 .8.3-.4 1.3-1.3 2-.8m-.2 1.8c-1.3 1.2-2.2-.3-2.2-1 .9 1.7 1.2 1.5 2.2 1M39 20.4c-.4 1.1.8 1.5.8 2-.4-.3-1.3-1.2-.8-2m1.9.3c1.1 1.2-.4 2.2-1.1 2 1.8-.7 1.5-1 1-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#730000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29.8 10q.3.2.2.3h-.1zm-.8 2.6v-.3h.1v.3Zm2.3-.5-.3.2h.1l.4-.1zM27 13.4l-.1.2-.2.3v.2q.2.4.2 1.2v.7l.2.2v-.1c.2-.2 0-1.9 0-2.3l-.2-.7v-.2q-.3-.4-.3-1.2s-.4.1-.8-.7q-.2-.4-.7-.4l.1-.1h.4v-.2l.2-.1v.6q.1.4.6.7.2 0 .3-.5v-.6l.1.1v.2l.2-.1-.1.3-.1.7v.6l.3.6.2.3.1.4.2.6v.6q0 .2.4 0l.2-.6h.1l.1.1v.3l.6-.4h.3l-.1.2h.3l-.6.3-.7.3q-.4.1-.6.4v1.8h-1s.2-.6 0-.8l-.8-.9c-.2-.2.2 0 .2 0v-.2l.4.5s.7-.6 0-1.5l-.6-.7h-.6q-.6.3-1.3-.4h.2l.2-.1q-.1.2.6.3.8.1.6-.6h.3v.5q0 .2.4.4h.4l.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#730000",
    d: "m27.3 13 .1-.3.4-.5v-.7l.2.1v.3l.2-.2zM23 11.1q0 .2.3.5h.1l-.3-.5zm.7-.2v.6h.1V11M28 9.7l.1 1h.2v-.2l.7-.3V10l-.4.3h-.3l-.1-.5zm1.8 2.8v.6l.1-.6zm.6.3-.4.3.3-.1.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29.8 12.5v.6l.1-.6h-.1m-2.6.4.2-.2.4-.5v-.7l.2.1v.3l.2-.2-.9 1.4zM23 11.2q0 .2.3.5h.1l-.3-.5zm.7-.2v.6h.1V11ZM28 9.7l.1 1h.2v-.2l.7-.3V10l-.4.3h-.3l-.1-.5zm2.4 3-.4.4.3-.1.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#289400",
    stroke: "#030",
    strokeWidth: 0.1,
    d: "M27.9 11.5v.1h.2l.3.2.1.3h.1v.2h.5l.1-.1q-.6-.3-.5-.6.5-.4.7-.1l1.6.8v-.4l.2.2h.3l.3.3q.2 0 0-.2l.4.3v-.1l.2-.4.2-.2.1-.1v-.1l-.2-.1.1-.2-.2-.2-.2-.2-.2-.2.2-.1-.4-.2h.2-.4V10l-.2.1H31l-.1-.3-.1.2-.3.1V10l-.1.2V10l-.2.3-.1.2h-.2l-.1.1h-.2v.2l-.2-.2H29l-.1-.2v.3h-.4v-.2l-.1.2H28v.2h-.3q-.1 0 0 .1h-.5v.2l-.1.2h.1v.1l-.2.3h.3v-.1l.2-.1h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#289400",
    stroke: "#030",
    strokeWidth: 0.1,
    d: "M27.7 9v-.2h.4v-.1q.2 0 .3.2l.5-.1V9h.5l-.1.2.6.1q.3.2 0 .2l.3.4-.4.1h-.2v.2l-.3-.2q-.1 0 0 .2l-.5-.3-.2.1-.2-.2H28l-.1-.1-.1-.2-.2.2-.1-.2h-.3l.2-.4zm-1.6 1.1v.1h-.2l-.1.2v-.1l-.2.1h-.2l-.2.2v-.2l-.2.2h-.4v-.4l.1-.3v-.2l.2-.1q.1-.1 0-.2l.3-.2V9h1.1l.2.2h.3v.3h.3v.3h.3v.3l.5.2-.2.1v.3h-.2v.1h-.3l-.1-.1v-.1h-.3v-.2l-.2.1v-.1h-.1l-.1-.1v.1l-.2-.2Zm-2.6.9.4.2v-.3l.2.1v-.2h.3q.2 0-.2-.4h.2v-.2h.2l-.4-.1v-.3h-.5l-.1-.2-.2.1-.3.1H23l-.1.2h-.4v.3h-.2v.1l-.2.2h.1v.2H22h.1v.7l.2-.3-.2.3.3-.2.2-.1h.6v.1-.1h.1l.1-.3zm-1 1v.3l-.2.2v.4l-.1.2.6-.4.8-.4h.3l.1.4.1.4h.2l.3-.1h.3l.2-.1h.2v-.1l.3-.1.1.1.2-.2.1.2.3.1.1-.2.3.1-.1-.3.1-.2h-.1v-.2l-.2-.1v-.2l-.5-.2.1-.1-.1-.1h-.4l-.2-.2-.2.2h-.3l-.2-.2-.3.3q0 .1 0 0h-.6l-.2.1-.2.2H23v.2zm3.6 3.4v-.2l.2.1.1-.1.2.1v-.1.2l.3-.2h.1v-.4h.2l-.3-.3h-.1l-.3-.3h-.4l-.2-.1H25v.1l-.3.2h-.2v.1l-.2.1v.1l-.3.2.1.1h-.3v.1l-.2.3.2.1-.1.2.3.1.1.2h.3v.2l.4-.3.3.2v-.3h.1v-.2h.1l.2-.2.3.3.2-.4zm1.6-1V14l-.1.1v-.3h-.2v-.6l.1-.1.3-.3h.5v-.1h.4l.3-.1h.1v.2h.5l-.2.2h1v.1h.3v.1l.2.2h.3v.3l.3.3h.2q0 .2-.2.3v.2l-.2.3-.1-.1-.1.2-.4-.4-.1.2-.3-.3v.2l-.3-.2-.2.1-.2-.3H29l-.1-.4v.3l-.2-.2-.3.3V14l-.2.2-.1-.2-.1.2-.2-.2zm0 .8v-.1l.5-.2.4-.1.2-.1.1.1.1-.2.2.3.1-.2.1.1h.2v.2h.4v.2h.3l.1.4.1.4q-.1.1-.2-.1v.3h-.4l-.2.2-.3-.2v.2L29 16l-.2.1-.1-.3-.2-.2-.4.4v-.3l-.3.1v-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#004b00",
    strokeWidth: 0.1,
    d: "M29.9 10.4v.1h.3v.2h.2v.1l.2.1-.2.2.4.2-.3.2v.3h-.3m1.1-.4V11l.3.2q.1-.1 0-.2h.3v-.1h.2m-3.8-1.3v-.1c-.2-.3.2.2.3.2m.3 0h.2v-.2l.3.1.1-.2.4.1m-2.1 0v-.3m-2 1V10v.1l.1-.2.2-.1h.6v-.2m-1.6.8v-.2m-2 .8v-.4l.2.1m.8 0q0-.2-.3-.2m-1.3.7V11m2 4.4.2-.3.1.3.1-.2v.1l.2-.2.3.3m3.3-1.4.2-.2h.2v-.2l.3.1v-.2h.3v-.2l.2.2v-.2h.2v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#004b00",
    strokeWidth: 0.1,
    d: "m29.3 13.6.2.3.2-.2.1.3.2-.1.3.2v-.2l.4.3v-.3h.4l.1-.2m-7-.8v-.2l.3.1v-.3l.4.3v-.4l.3.1.1-.1h.3v-.2l.3.1-.2-.2h.3v-.3m2.5 3.8.2-.1.2.2.1-.3.3.2v-.2h.5v-.1h.2v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9dd7ff",
    d: "m24.3 24.8-.5-1 3.5-3.1 3.5 3-.5 1.2-.3-.1-.2.1h-.5l-.2-.1-.3.1h-1l-.3-.1-.2.1-.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.3 17v3.7l-3.5 3-.4-2.2v-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.3 17v3.7l-3.5 3-.4-2.2v-4.4h3.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83c",
    d: "M27.3 17v3.7l3.5 3 .4-2.2v-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.3 17v3.7l3.5 3 .4-2.2v-4.4h-4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#730000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m25 24.1.7.3 1.8.2h1.2l.3-.2-.6.5s-2.2.1-2.6-.1L25 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28.2 23s.7.5 0 1.2m-3.1 0 1-1-.1 1.3m.5 0v-2m1.7 2v-2.2m-.8 2.3v-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0018",
    d: "M26.5 22.6H26l.5.1zm.9-.4-.5.2h.5zm.8.1-.5.2h.5zm.3 1h.3v.5h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m27.4 22.2-.5.2h.5v-.2m-.9.4H26zm1.7-.3-.5.2h.5zm.3 1h.3v.5h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m25.2 24 .9-.8v.5s-.5.3-.5.5zm.5.2.3-.4v.5zm1.2-1.5h.6v.5s-.5-.2-.6 0zm-.7.1h.6v.5h-.6q-.2-.1 0-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.2 23.3h.6v.4H26zm.7 0 .7-.1v.5s-.5-.2-.7 0v-.5m-.8.5h.7v.6H26q-.2-.1 0-.6m.8 0h.8v.7s-.7-.2-.8 0c0 0-.2-.5 0-.7m.9-1h.6v.4s-.5-.2-.7 0zm0 .4h.6v.4l-.7.1zm0 .5h.6v.6q-.1-.2-.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.1 23.8c.2-.2.7-.1.7-.1v-.4h-.6zm0 0q-.2.4 0 .6h.7v-.6H26Zm.8-.6h.7v.5s-.5-.2-.7 0zm0 .6h.8v.7s-.7-.2-.8 0q-.2-.2 0-.7Zm.9-1h.6v.4s-.5-.2-.7 0zm0 .4h.6v.4l-.7.1zm0 .5h.6v.6q-.1-.2-.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28.5 23.8s.1.4.3.4l-.2.3-.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006ac8",
    d: "M30.3 24.9q-1.1 1.7-3 2.4a6 6 0 0 1-3-2.4l.3-.2.2.1H27l.3.1.2-.1.3.1h1l.2-.1.3.1h.5l.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M30.1 25.1h-3.2l-.3-.1h-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ac800",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m25 25.4-.1.1h-.1l1 1q.5.4 1.5.7a6 6 0 0 0 2.5-1.7l-.3.1h-1l-.3-.1-.4.1-.3-.1-.2.1-.4-.1h-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd800",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.3 27.2q.8-.2 1.4-.7h-.4l-.4-.1h-2.1q.7.6 1.5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b34b00",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m26.8 20.8.2-.4h-.3l-.2-.1q0-.2-.3-.3l-.7-.9q-.2-.2-.2-.5l-1.1-1.1q-.2-.2-.4 0t0 .5l1 1 .5.2 1 1.2q.3 0 .2.3v.1h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m24 17.8 1.2 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M25.6 18.3v-.2l.5-.5 1 .7-.5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccb8c8",
    d: "m26.2 18.5-.6-.3v.2l1 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m25.7 18.2.4.2.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#782121",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m23.8 21 2-2.6q.2 0 .3.2l-2 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#730000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M30.9 21.1h-.2l-.5-.5-2-2.6.1-.2 2 2.3.7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m28.8 18.4-.3-.5-.3.2-.7.4q-.1.1.7.9s.2-.6.4-.7q.2 0 .2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#730000",
    d: "M28 20.2h-.3V20h.5zm2.3-2.3v-.4q-.3.2-.1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28 20.2h-.3V20h.5l-.2.2m2.3-2.3v-.4q-.3.2-.1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m28 20.2 2.4-2.4.5.6h-.1v.2h-.1v.1h-.2v.2h-.2v.2h-.2v.1H30v.2h-.2v.2h-.2v.2h-.1v.1h-.2v.2h-.2v.2h-.2v.1h-.1v.2h-.1v.1h-.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7e4b7e",
    d: "m30.2 18-.2.2v.6h.2zm-.3.4h-.2v.7q0-.1.2 0zm-1.5 1.4-.1.1v.4q0-.1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7e4b7e",
    strokeWidth: 0.1,
    d: "m28.2 18.2.4.4m-.2-.2-.2.2m.2-.2-.1.3m-.1-.3-.4.2m.3-.2-.3.2m.3 0h-.2m.1 0-.1.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7e4b7e",
    strokeLinecap: "square",
    strokeWidth: 0.1,
    d: "m26.6 18.7.1-.2.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#289400",
    stroke: "#060",
    strokeWidth: 0.1,
    d: "M18.7 25.3q.2-.1 0-.6c.1-.2.5.4.7.5s1.2-.4 1.2-.4l.3-.5.1.4.4-.5c.1-.1 0 .3 0 .4-.2.1.2.2.1.5 0 .2.4-.2.4-.2h1l.4-.9.1.4.4-.4a6 6 0 0 0 3.5 3.3 6 6 0 0 0 3.3-3.1l.6.6.5-.2 1.3.5v-.3s.5 0 .5.3l.2-.3.3.3 1.2.3.2.3h.3v.2l-.3.3h.2q.3.2-.4.5l.1.2H35l-.1.3-.5-.2v.2s-.6 0-.7-.3l-.2.2-.5-.3-.1.1-.4-.1-.4-.2-.2.3-.4-.2-.1.1-.4-.1v.2h-.6v.1l-.4-.2v.2h-.4l-.2.2H29v.2h-.7v.2H28v.1s-.6-.2-.8 0l-.2.1q-.2 0 0 0l-.2-.3-.3.1-.6.1v-.2h-.4l-.2-.2q-.1-.2-.2 0v-.2h-.4l-.2-.2H24h.1-.8l.2-.2-.7-.2-.8.1-.2-.1-.3.2v-.3s-.4 0-.4.2l-.1-.3-.3.4v-.1l-.4.3v-.2s-.7.4-.9.3l.1-.2h-.4l-.4-.1h.4q-.2-.2-.7-.2l.2-.2-.5-.3h.4l-.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#730000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m18 15.7 6-3q0-.3-.2-.4-2.4 1.4-5 2.4c-.2 0-1.1.4-1.6 1l-.2.4.1.3.1.2h.1l.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m22.8 12.7.8-.4q.2 0 .2.4s.1.6.7.9c0 0-.5.7-1.4.7l-.1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7e4b7e",
    strokeWidth: 0.1,
    d: "m23.7 12.8-.6.3m.4-.1v.4m0-.4v.4m-.2-.4v.3m.4-.2.4.5m-.3-.4.2.4m-.2-.2.1.3m-.1-.2v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b34b00",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m29.2 12.4 2.2 1 .8.2 4.3 2.1q.6.2.5.4.1.4.2.3h.2v-.1h.1q.3-.5.1-.7h-.4l-.6-.2-.6-.4c-.3 0-2.4-1.2-3.5-1.8-.1 0-.2-.5-.5-.6l-2.4-1.2q-.5-.3-.7.1-.4.5.4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m29.4 11.9 2.4 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m22.1 13.2-.1.4-.3.2c-.1 0-.3.3-.6 0q0 .2-.3.5l-1.3.7v.6q-.2.1-.3.5l-.3-.2.1-.4V15l-.2.1h.2v.4l-.8.3.1.2.3 1.2q.3.5.4.3l.1.2.4-.1q0-.3.2-.3l.5-.6.2 1 1.3.1.9-.1V17l.2.4q.1.4.4.5l.3-.3v-.5h1.1q.2 0 0 0h.6l-.4-.3-.3-.1H24l-.5.1c0-.1 0-.7-.2-.9v-1.1q0-.2-.6-.4-.5 0-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.7 12.3v.7l.1.6.3.3q.3.2.7-.1l.2-.2v-.4h.1l.1-.2-.1-.2v-.6l-1.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.7 12.4V12l.2-.1h.3l.7-.1.3.3.1.6v.3H22v-.7l-.6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1,
    d: "m21 12.1-.1-.2.1.2q0 .2 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.2 12.8v.3m.8 0v.1m0-.3q.2 0 .1.1m-1.4-.4.2.1q.2 0 0 .3v.2h.4m0-.4.1-.1h.4m-.4 1-.4-.1m0 0q0-.2.1 0l.1-.1h.2m-.4 0h.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.7 12.8h.3l-.1.1zm.7 0h.3v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M20.8 13v-.2zm.7 0v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M25 17.1V17l-.2-.1h-.2m0 .1h-.1l-.2-.1m-5-.8.2.4.1.3m-1-.6q-.1.3.4 1m-.4-1.7v.3m1.2.8.4-.4m-.1.4v-1.4s.1.7-.3.8m2.7 1 .1-.5v-.7q.1-.1 0-.8s.3.9-.3.9q-.7-.1-.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20 15.2q-.2.5.8.7.4 0 .6-.3m.2-.2V15m-1.1-.3h.7m0-.6q0 .4.3.6m.4-.6-.1.3m0 .3h.7m.1 1.8.3.4m-2.5-.9v.8a1 1 0 0 1-.1.9m.5-1.6-.2.4m.5-.1-.3.9q.1-.1.2.5m.6-1.7v.2m.3 0c0 .1.4.5.3.7m-.6-.5v.7m-.2 0-.2.2m.7-.2.2.6m1.3-.9-.2.1-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M20.5 15.8h.1zm1.9 0h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.8 19.2q.2-1.1.4-1.2h.8l1 .1h.5l.1.3.2 2.7v1l.3 3.2h-1.4l.1-3.4-.1-.5-.3-1-.5 1.6-.2 3.3-.7.6-.7-.4.3-2.7V22c0-.1 0-2.2.2-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.9 22q0 .3-.3.5m-.2-4.3s-.2.6-.6.8m1.1-.7c0 .2-.4 1.8-.5 3.6m0 .6-.1 1.6m0 .3q-.3.7-.3 1.5m2.6-3c0 .2-.1 1.3.3 2.3m-1.5-6.9v1.5l.1.2-.2.5m-.3-1-.2.9m1-2h.5s0 2.3.3 3.6m-1-3.4V20m.2.2.1.3m-1.4-2.2h.2m.5.2v.4m.6 3v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9b5f00",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m20.1 18 .1-.4h.7l1 .1.6-.1v.4l-.6.1L20 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.4 18v-.4h.1zm1.7-.3v.4h.2v-.5zm-1.2 0v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.4 18v-.4h.1v.4h-.1m1.7-.3v.4h.2v-.5zm-1.2 0v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa54b",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m19.5 25.7-.1.4v.3q.3-.2.2-.3v.3q.3-.1.2-.2v.3l.2-.3v.3l.1-.3.2.4.1-.3v-.7l-.4.2zm2.4-.4v.2q-.1.2.2.3h1.8l.1-.2h-.2l-.4-.1-.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb366",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.8 15.2V15l.2-.2.2-.2h.3l.2.2v.2l-.1-.1v.2h-.4v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M18.6 14.9q0-.2-.3-.2m.1.3q0-.2-.4-.2m.2.3q-.3-.2-.4-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M32.5 13.2v.4l.2.2q.3.2.8 0 0 .2.3.5l1.3.7v.6l.3.5.3-.2-.2-.4V15l.2-.1.1.1h-.1v.4l.8.3-.1.2s-.1.8-.4 1.2l-.3.3-.2.2-.3-.1q0-.3-.3-.3l-.5-.6-.1 1-1.3.1-1-.1V17l-.1.4q-.1.4-.4.5t-.3-.3v-.5h-1.1q-.2 0 0 0h-.6l.3-.3.4-.1h.5l.5.1V16l.1-.4V15q0-.7.6-.7.5-.2.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M32.5 13.2v.4l.2.2q.3.2.8 0 0 .2.3.5l1.3.7v.6l.3.5.3-.2-.2-.4V15l.2-.1.1.1h-.1v.4l.8.3-.1.2s-.1.8-.4 1.2l-.3.3-.2.2-.3-.1q0-.3-.3-.3l-.5-.6-.1 1-1.3.1-1-.1V17l-.1.4q-.1.4-.4.5t-.3-.3v-.5h-1.1q-.2 0 0 0h-.6l.3-.3.4-.1h.5l.5.1V16l.1-.4V15q0-.7.6-.7.5-.2.6-.5v-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m33.8 12.3.1.4v.2l-.2.7-.2.3q-.5.1-.8-.1l-.1-.2v-.3h-.1l-.2-.3.2-.2v-.6l1.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33.9 12.4v-.3l-.2-.2-.2-.1h-.9l-.3.3v.8h.2v-.7l.7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33.4 12.8v.2m-.8.2h-.1m1.4-.5h-.3v.5h-.3m0-.4-.2-.1h-.4m1 .8h-.5m.4 0h-.4m0 .1h.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.8 12.8h-.2l.1.1zm-.6 0h-.3v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M33.7 13v-.2h.1zm-.7 0v-.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m29.6 17.1.1-.1.2-.1h.2m0 .1h.1l.2-.1m5-.8-.3.4v.3m1-.6q.1.3-.5 1m.4-1.7v.3m-1.1.8-.4-.4m0 .4v-1.4s-.1.7.3.8M32 17v-1.2q-.2-.1 0-.8s-.3.9.3.9q.8-.1.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.5 15.2c0 .2 0 .7-.7.7q-.4 0-.6-.3m-.2-.2V15m1.1-.3h-.7m0-.6q0 .4-.3.6m-.4-.6v.3m0 .3H32m0 1.8-.4.4m2.6-.9v.8a1 1 0 0 0 0 .9m-.4-1.6.2.4m-.6-.1.4.9q-.2-.1-.2.5M33 16l-.1.2m-.2 0-.4.7m.6-.5v.7m.2 0q.2 0 .3.2m-.7-.2-.3.6m-1.2-.9.2.1.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M34 15.8h.1zm-1.8 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m34.8 19.2-.4-1.2h-.9l-.9.1h-.5l-.1.3-.2 2.7v1l-.3 3.2h1.4l-.1-3.4v-.5l.4-1 .5 1.6.1 3.3.8.6.7-.4q0-1.4-.4-2.7V22z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33.7 22q0 .3.3.5m.2-4.3s.2.6.6.8m-1.2-.7c.1.2.5 1.8.5 3.6m0 .6.2 1.6m0 .3q.3.7.3 1.5m-2.6-3c0 .2 0 1.3-.3 2.3m1.5-6.9v1.5l-.1.2.1.5m.3-1 .3.9m-1-2h-.5L32 22m1-3.4V20m-.2.2-.2.3m1.5-2.2h-.3m-.4.2v.4m-.6 3-.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9b5f00",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.4 18v-.4h-.7l-1 .1-.6-.1v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.2 18v-.4H34v.4m-1.7-.3v.4zm1.3 0v.4l-.1-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.2 18v-.4H34v.4m-1.7-.3v.4-.5Zm1.3 0v.4l-.1-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#730000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m35 25.7.2.4-.1.3-.1-.3v.3l-.2-.2v.3q-.2-.1-.2-.3v.3q-.2-.1-.2-.3l-.1.4-.2-.3v-.7l.5.2zm-2.3-.4v.2q0 .2-.2.3h-1.8l-.2-.2h.3l.4-.1.4-.2zm4-9.8v-.3l-.2-.1-.2-.2H36l-.2.2v.2l.1-.1v.2l.2-.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36 15.2q0-.3.3-.2m-.2.3.4-.2m-.2.3.1-.1h.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#730000",
    d: "m36 15-.2.1v.2l.2.1.1.1h.2q0 .2.1 0h.3l-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.8 15v.3q0 .2.3 0 0 .3.2.2m0 0q0 .2.2 0h.2m-.4 0q0-.2.2-.2m-.4-.3q-.3 0-.2.3m.4-.2q-.2 0-.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ac800",
    d: "M20.5 25.9v-.4l.2.1v-.2h.2v-.2l.2.3V25l.3.3.1-.2.1.4.1-.1.1.3.2-.3.2.4h.3v.1l.2-.1h.5l.2.2.1-.2.2.1.1-.2.2.2v-.2h.2l.2-.3.1.2.1-.2.3.4s-1.4.5-2.3.4zm9.3 0 .1-.3.2.3.1-.1h.3l.2.1.2-.1.2.1h.5l.2-.2.1.2.2-.2.1.1.3-.1h.2v-.1q.1-.1.2 0l.2-.2v.3l.4-.1v.4s.1-.4.2-.2v.4l.2-.1v.2h.2H32c-1.1 0-2.1-.4-2.1-.4m-.8.8s-.4.8-1.4.9c-1.4 0-2.6-.7-2.6-.7l.2-.3.3.4v-.3l.4.3.1-.2.1.3.3-.2.2.4.2-.1.2.3.4-.2.3.2.3-.4.1.1.2-.3.1.2.2-.3.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#060",
    strokeWidth: 0.1,
    d: "M20.5 25.9v-.4l.2.1v-.2h.2v-.2l.2.3V25l.3.3.1-.2.1.4.1-.1.1.3.2-.3.2.4h.3v.1l.2-.1h.5l.2.2.1-.2.2.1.1-.2.2.2v-.2h.2l.2-.3.1.2.1-.2.3.4m4.9 0 .1-.3.2.3.1-.1h.3l.2.1.2-.1.2.1h.5l.2-.1h.1l.2-.1.1.1.3-.1h.2v-.1q.1-.1.2 0l.2-.2v.3l.4-.1v.4s.1-.4.2-.2v.4l.2-.1v.2h.2m-9.1.6.2-.3.3.4v-.3l.4.3.1-.2.1.3.3-.2.2.4.2-.1.2.3.4-.2.3.2.3-.4.1.1.2-.3.1.2.2-.3.1.2.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.3 30.2c1.8 0 3-.7 3.5-1 1.4-1 1.7-1 2-1q.5 0 .6.3c0 .4-.6.5-.9.5l-1.2-.2-.2.1c.1.1 1.9.7 2.2.1l.7-1.4s-.4-.7-1.2-.7q-1.4.1-2.3 1c-.6.3-1.3 1-3.2 1s-2.6-.7-3.2-1q-1-.9-2.3-1a2 2 0 0 0-1.3.7l.7 1.4c.4.6 2.2 0 2.3 0l-.2-.2-1.2.2c-.4 0-1-.1-.9-.5q.1-.3.7-.3c.2 0 .5 0 1.9 1a6 6 0 0 0 3.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.3 28v-.4q0-.4-.3-.3l-.3.2-.2-.1.5-.3s1.2.4 1.6.8v.7q-.6-.1-1.3-.6m-.5 1.1-.2.7q0 .8.6.6.5 0 .5-.8zm6.4-1.1v-.4q.1-.4.4-.3l.3.2.2-.1-.5-.3s-1.2.4-1.6.8v.7zm.6 1.1.2.7q-.1.8-.6.6-.5 0-.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69f",
    d: "M23.3 28.8 22 29c-.4 0-1-.1-.9-.5q.1-.3.7-.3c.2 0 .4 0 1.4.6m8 0 1.2.2c.3 0 .9-.1.9-.5q-.1-.3-.7-.3c-.2 0-.4 0-1.4.6m-7-.8-.2-.2-.4-.2.3-.3q.2 0 .3.3zm-.6 2.3h.5q.5.1.5-.7l1 .4.1.3q0 .4-.3.4l-1.3-.2zm6.5-2.3.3-.2.4-.2-.3-.3q-.2 0-.3.3zm.6 2.3h-.4q-.5.1-.6-.7l-1 .4v.3q0 .4.2.4l1.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.3 30.2c1.8 0 3-.7 3.5-1 1.4-1 1.7-1 2-1q.5 0 .6.3c0 .4-.6.5-.9.5l-1.2-.2-.2.1c.1.1 1.9.7 2.2.1l.7-1.4s-.4-.7-1.2-.7q-1.4.1-2.3 1c-.6.3-1.3 1-3.2 1s-2.6-.7-3.2-1q-1-.9-2.3-1c-.9 0-1.3.7-1.3.7l.7 1.4c.4.6 2.2 0 2.3 0l-.2-.2-1.2.2c-.4 0-1-.1-.9-.5q.1-.3.7-.3c.2 0 .5 0 1.9 1a6 6 0 0 0 3.5 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M23.3 28.8 22 29c-.4 0-1-.1-.9-.5q.1-.3.7-.3c.2 0 .4 0 1.4.6Zm8 0 1.2.2c.3 0 .9-.1.9-.5q-.1-.3-.7-.3c-.2 0-.4 0-1.4.6Zm-7-.8-.2-.2-.4-.2.3-.3q.2 0 .3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M24.3 28v-.4q0-.4-.3-.3l-.3.2-.2-.1.5-.3s1.2.4 1.6.8v.7q-.6-.1-1.3-.6m-.5 1.1-.2.7q0 .8.6.6.5 0 .5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m24 29.3-.2.5q0 .4.4.4.5-.1.2-.7l-.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M23.7 30.3h.5q.5.1.5-.7l1 .4.1.3q0 .4-.3.4l-1.3-.2zm6.5-2.3.3-.2.4-.2-.3-.3q-.2 0-.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M30.2 28v-.4q.1-.4.4-.3l.3.2.2-.1-.5-.3s-1.2.4-1.6.8v.7l1.2-.6m.6 1.1.2.7q-.1.8-.6.6-.5 0-.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m30.6 29.3.2.5q0 .4-.4.4-.4-.1-.3-.7l.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M30.8 30.3h-.4q-.5.1-.6-.7l-1 .4v.3q0 .4.2.4l1.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.1,
    d: "M25.6 30.1s.3.2 0 .5m-.8-.6.9.4m-.7-.2.6.2m-.4-.4.4.2m3.3 0q-.1 0 0 .4m.8-.6-.8.4m.7-.2-.6.2m.4-.4-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22.4 27.6v.3H22v-.3.1l.1.1h.2v-.1l-.1-.1-.1-.2v-.1l.1-.1h.3v.3-.1h-.1v-.1h-.2v.1zm1 .1h-.1v.1l-.2.3-.2.1h-.1l-.1-.1v-.2l.1-.4v-.1l.3.1H23l-.3.4v.1l.1.1h.2l.2-.3v-.2zm.4.7v.1l-.2.1h-.1l-.3-.2h.1l.3-.5v-.1l.2.2h.1a.1.1 0 0 1 0 .3h-.2Zm0-.2V28h-.1l-.1.2zm-.1.3v-.2h-.1l-.2.1v.1h.2Zm1.6.3h-.1l-.1.1-.1.3h-.1v.1h-.2l-.2-.1V29l.1-.4v-.1l.3.1h-.1l-.2.4a.1.1 0 0 0 0 .2h.3l.1-.3v-.2h.3zm.7 1-.3-.2h.1l.2-.5-.4.5v-.7l-.2.4v.2h-.2l.1-.1.1-.4v-.2h.2v.6l.3-.3V29h.3-.1v.1l-.2.5h.1zm.7-.3.1.1v.1h-.6.1V29h.4a.1.1 0 0 1 .1.2l-.1.1Zm0-.1v-.2h-.2v.2zm0 .2v-.1h-.2v.2h.1zm1 .2h-.3v-.2l-.2-.1v.3H27h.1v-.6h.4v.5h.2zm-.3-.5v-.1h-.2v.3h.1zm1 .5h-.2v-.2h-.3v.2h-.2.1v-.1l.1-.3.1-.3.3.6h.1Zm-.3-.3v-.3l-.2.3zm1.3-.6H29v.3h.2V29l.1.2-.1-.1h-.1v.3h.1l-.2.1V29h-.1zm.8 0 .1.2-.5.2v-.1l-.2-.4v-.1l.2-.1v.1l.1.4h.2zm.4-.7h.1l.1.2v.5h-.5l-.1-.5.2-.2zm.2.5v-.3h-.2v-.1h-.3v.3l.1.2h.3zm.9-.5-.2.1h-.2l-.1-.1H31l.1.2h.1l-.2.2v-.1l-.3-.5.2-.2h.1l.2.1v.2h.3Zm-.5-.3h-.3l.2.3V28Zm1-.1.1.1-.5.3V28l-.2-.5v-.1l.4-.2v.2-.1h-.3l.1.3h.1v-.2h.1l.1.3h-.3l.1.2h.3v-.2Zm.6-.5h.1v.4l-.3.2h-.2v-.3q-.2 0 0-.2l.2-.2h.2Zm0 .5v-.5h-.3v.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M31.2 17v4.5c0 .9-.1 4.4-4 5.8a6 6 0 0 1-3.8-5.8v-4.4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.53157 0 0 2.34864 21.6 15.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffef5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea5700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.79385 0 0 .90584 21.4 13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffef5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea5700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.5257 0 0 2.35256 33 15.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#952d1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#570a00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.8183 0 0 .89544 33.1 13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#952d1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#570a00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBz);
export default __webpack_public_path__ + "static/media/bz.4953b9fbcff37ddd085d78dd782042bc.svg";
export { ForwardRef as ReactComponent };